export default __webpack_public_path__ + "static/media/AngularJS.acdcdac1.svg";